import { render, staticRenderFns } from "./UnitList.vue?vue&type=template&id=e452404e&"
import script from "./UnitList.vue?vue&type=script&lang=js&"
export * from "./UnitList.vue?vue&type=script&lang=js&"
import style0 from "./UnitList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "UnitList.vue"
export default component.exports